import React, { useEffect, useState } from "react";
import TeamService from "services/TeamService";
import slackMainLogo from "assets/img/slack-main-logo.png";
import Loader from "components/Loader";
import * as moment from "moment";
import DisconnectSlack from "components/DisconnectSlack";
import ConnectToSlack from "components/ConnectToSlack";
import "assets/scss/helpers/slackstyle.scss";

export default ({ team}) => {
  const [loading, setLoading] = useState(true);
  const [slackData, setSlackData] = useState();
  const [slackErrorMessage, setSlackErrorMessage] = useState();
  const loaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await TeamService.getUserSlackInformation(team.id);

        setSlackData(response.data.data);
      } catch (error) {
        setSlackErrorMessage(error.response.data.message);
      }
      setLoading(false);
    })();
    //eslint-disable-next-line
  }, [team]);

  return (
    <div className="slackRoot">
      <div className="slackIcon">
        <img alt="slack Main Logo" src={slackMainLogo} className="icon" />
      </div>
      {loading && (
        <div style={loaderStyle}>
          <Loader />
        </div>
      )}
      {!loading && slackData && (
        <>
          <div className="slackContent">
            <div className="slackHeading">
              <span>Channel Name</span>
              <span>Created At</span>
              <span>Slack Team Name</span>
            </div>
            <div className="slackData">
              <span className="slackName">{slackData.channel}</span>
              <span>{moment(slackData.created_at).format("MMM DD, YYYY")}</span>
              <span className="slackName">{slackData.slack_team_name}</span>
            </div>
          </div>
          <DisconnectSlack
            team={team}
            setSlackData={setSlackData}
            setSlackErrorMessage={setSlackErrorMessage}
          />
        </>
      )}
      {!loading && !slackData && (
        <div>
          <div className="noSlackMessage">
            <span>{slackErrorMessage}</span>
          </div>
          <div className="connectContent">
            <ConnectToSlack team={team} />
          </div>
        </div>
      )}
    </div>
  );
};
